import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Scoresummary from './Index'
import Preview from './Previewtable'

export default () => (
  <Switch>
    <Route exact path="/report/scoresummary" component={Scoresummary} />
    <Route exact path="/report/scoresummary/preview" component={Preview} />
  </Switch>
)
